import { Accordion, AccordionDetails, AccordionSummary, IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { toSpanishDate } from "../../../helpers/dateFormat";
import { numberFormat } from "../../../helpers/numberFormat";
import { TableLayout } from "../../layout/TableLayout"
import { EditDivestmentLP } from "./EditDivestmentLP";
import { useState } from "react";
import { selectDivestmentLP } from "../../../store/divestmentLP/divestmentLPSlice";
import { useDispatch } from "react-redux";

export const AdminLPTable = ({ rows, setReloadData }) => {

    const { t } = useTranslation('global')
    const [openEdit, setOpenEdit] = useState(false);
    const dispatch = useDispatch()
     
    const onEditClick = (e) => {
        dispatch(selectDivestmentLP(e.row))
        setOpenEdit(true)
    } 

    const columns = [
        {
            field: 'investmentDate',
            headerName: t('divestment.investmentDate'),
            minWidth: 130,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <Typography color='primary' variant='body2'>{toSpanishDate(params.row.investmentDate)}</Typography>
        },
        {
            field: 'startupName',
            headerName: t('positions.startup'),
            minWidth: 115,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'roundNumber',
            headerName: t('positions.roundNumber'),
            minWidth: 115,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'amount',
            headerName: t('positions.amountDivestment'),
            minWidth: 130,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ row }) => numberFormat(((row.participationValuation * row.divestmentParticipation)).toFixed(2))
        },
        {
            field: 'participationValuation',
            headerName: t('positions.participationValuation'),
            minWidth: 160,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => {
                const resp = params.row.participationValuation;
                return (isNaN(resp) || resp === null || resp === 'Infinity' ? '-' : numberFormat(resp))
            }
        },
        {
            field: 'shares',
            headerName: t('positions.shares'),
            minWidth: 150,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ row }) => {
                const resp = ((row.divestmentParticipation)).toFixed(2)
                return (isNaN(resp) || resp === null || resp === 'Infinity' ? '-' : numberFormat(resp))
            }
        },
        {
            field: 'salesPrice',
            headerName: t('divestment.salesPrice'),
            minWidth: 130,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ row }) => {
                const resp = numberFormat(row?.salesPrice);
                return (resp === 'NaN' ? '-' : resp)
            }
        },
        {
            field: 'capitalGain',
            headerName: t('positions.capitalGain'),
            minWidth: 140,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            valueGetter: ({ row }) => {
                const capitalGain = (row.divestmentParticipation * row.salesPrice) - (row.participationValuation * row.divestmentParticipation)
                return (isNaN(capitalGain) ? '-' : numberFormat((capitalGain).toFixed(2)))
            }
        },
        {
            field: 'divestmentDate',
            headerName: t('divestment.divestmentDate'),
            minWidth: 145,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <Typography color='primary' variant='body2'>{toSpanishDate(params.row.divestmentDate)}</Typography>
        },
        {
            field: 'tacc',
            headerName: t('divestment.tacc'),
            minWidth: 130,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({row}) => {
                const divestmentDate = new Date(row.divestmentDate)
                const investmentDate = new Date(row.investmentDate)
                const diffDates = (divestmentDate.getTime() - investmentDate.getTime())/ 86400000
                const exponent = (1 / (diffDates/365))
                const diffAmount = row.salesPrice / row.participationValuation
                const result = (((diffAmount ** exponent)-1) * 100).toFixed(2)
                return (<Typography color='primary' variant='body2'>{result}%</Typography>)
            }
        },
        {
            field: 'action',
            headerName: t('partnerlist.columnActions'),
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
            flex: 0,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Stack direction='row' gap={0}>
                        <IconButton color='secondary' onClick={() => onEditClick(params)}>
                            <EditRoundedIcon />
                        </IconButton>
                    </Stack>
                )
            }
        }
    ];

    return (
        <Stack>
            {
                rows.map(fund => (
                    <Accordion key={fund.id}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Stack direction='row' flexWrap='wrap' md={{ justifyContent: 'space-between' }}>
                                <Typography color='primary' marginRight='10px'>{t('divestment.fund')}: </Typography>
                                <Typography color='secondary'>{fund.name}</Typography>
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableLayout
                                rows={fund.divestmentData}
                                columns={columns}
                                title='noTitle'
                            />
                        </AccordionDetails>
                    </Accordion>
                ))
            }
                        {
                openEdit&&
                <EditDivestmentLP setHidden={setOpenEdit} setReloadData={setReloadData}/>
            }
        </Stack>
    )
}